import { render, staticRenderFns } from "./DetailMCode.vue?vue&type=template&id=be195ab0&scoped=true&lang=pug&"
import script from "./DetailMCode.vue?vue&type=script&lang=js&"
export * from "./DetailMCode.vue?vue&type=script&lang=js&"
import style0 from "./DetailMCode.vue?vue&type=style&index=0&id=be195ab0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be195ab0",
  null
  
)

export default component.exports